import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'th[sortableHeader]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div (click)="headerClicked()">
            <i [hidden]="sort.field === fieldName">
                <mat-icon>unfold_more</mat-icon>
            </i>
            <i [hidden]="sort.field !== fieldName || sort.desc">
                <mat-icon>expand_more</mat-icon>
            </i>
            <i [hidden]="sort.field !== fieldName || !sort.desc">
                <mat-icon>expand_less</mat-icon>
            </i>
            <ng-content></ng-content>
        </div>
    `,
    styles: [`
        i {
            position: relative;
            top: 5px;
        }
        
        mat-icon {
            color: lightgray;
        }
        
        div {
            cursor: pointer;
            width: 100%;
        }
    `]
})
export class SimpleGridSortableHeaderComponent {

    // map the sortableHeader input into a local var named fieldName
    @Input('sortableHeader') fieldName: any;

    // no mapping just create local reference sort which gets passed in
    // the sort points to same instance as the one from the host component
    @Input() sort: { field: string, desc: boolean };

    headerClicked(): void {
        if (this.sort.field === this.fieldName) {
            if (this.sort.desc === true) {
                this.sort.desc = false;
                this.sort.field = null;
            } else {
                this.sort.desc = true;
            }
        } else {
            this.sort.field = this.fieldName;
            this.sort.desc = false;
        }
    }

}
